<style lang="scss" scoped>
  .volumeBarWrapper{
    width: 20px;
    // height: 150px;
    display: grid;
    grid-template-rows: repeat(10 ,1fr);
    grid-row-gap: 5px;
    .volumeGrid{
      height: 10px;
      background: #ddd;
      &.active{
        background-color: rgb(24, 179, 24);
      }
    }

  }
</style>
<template>
  <div class="volumeBarWrapper">
    <span :class="{volumeGrid:true, active: index > 10-volume}" v-for="index in 10" :key="index"></span>
  </div>
</template>
<script>
  export default {
    data() { return {}; },
    methods: {},
    components: {},
    created() {},
    mounted() {},
    props: {
      volume: {
        type: [Number, String],
        default: 0,
      },
      gridCount: {
        type: Number,
        default: 10, // 用于显示音量的格数
      },
    },
    watch: {},
  };
</script>
